import {
  FieldErrorProps,
  Group,
  GroupProps,
  InputProps,
  LabelProps,
  FieldError as RACFieldError,
  Input as RACInput,
  Label as RACLabel,
  Form as RACForm,
  Text,
  TextProps,
  composeRenderProps,
  FormProps,
} from "react-aria-components";
import { cn, composeTailwindRenderProps } from "../../cn";
import { inputStyle, fieldGroupStyles } from "./commonStyles";
import { ReactNode } from "react";
import { IconType } from "../../foundations/Icons/types";
import Icon from "../../foundations/Icons/Icon";

export function Label(props: LabelProps) {
  return (
    <RACLabel
      {...props}
      className={cn(
        "font-medium text-md leading-7 text-grey-9 pl-4 mb-2 cursor-default w-fit",
        props.className,
      )}
    />
  );
}

export function Description(props: TextProps) {
  return (
    <Text
      {...props}
      slot="description"
      className={cn("text-sm", props.className)}
    />
  );
}

export function FieldError(props: FieldErrorProps) {
  return (
    <RACFieldError
      {...props}
      className={composeTailwindRenderProps(
        props.className,
        "text-sm text-red",
      )}
    />
  );
}

export function FieldGroup(props: GroupProps) {
  return (
    <Group
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        fieldGroupStyles({ ...renderProps, className }),
      )}
    />
  );
}

export function Input({
  leftIcon,
  rightElement,
  size = "l",
  ...props
}: Omit<InputProps, "size"> & {
  leftIcon?: IconType;
  size?: "l" | "sm";
  rightElement?: ReactNode;
}) {
  return (
    <div className="relative">
      <RACInput
        {...props}
        className={composeTailwindRenderProps(
          (props) => inputStyle({ hasLeftIcon: !!leftIcon, size, ...props }),
          "w-full",
        )}
      />
      {leftIcon && (
        <span
          aria-hidden="true"
          className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 flex"
        >
          <Icon icon={leftIcon} className="size-5" />
        </span>
      )}
      {rightElement && (
        <span className="absolute right-4 top-1/2 -translate-y-1/2 flex">
          {rightElement}
        </span>
      )}
    </div>
  );
}

export function Form(props: FormProps) {
  return (
    <RACForm
      {...props}
      className={cn("flex flex-col gap-4", props.className)}
    />
  );
}
